<div class="container">
  <div class="header-container">
    <h3 style="display: flex; align-items: center; gap: 5px">
      {{
        'lib_calendar.available-slot-selection-form.text.date-time-selection'
          | translate
      }}

      @if (isAbleToConfigTimeSlotDisplay()) {
      <button
        mat-icon-button
        color="primary"
        class="icon-button"
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin"
        (click)="isOpenAvailableSlotDisplayConfig = true"
      >
        <mat-icon>settings</mat-icon>
      </button>

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="isOpenAvailableSlotDisplayConfig"
        [cdkConnectedOverlayHasBackdrop]="true"
        (overlayOutsideClick)="isOpenAvailableSlotDisplayConfig = false"
      >
        <lib-base-card style="max-width: 400px">
          <div class="card-content">
            <div>
              {{
                'lib_calendar.available-slot-selection-form.text.slot_tact'
                  | translate
              }}
            </div>

            <mat-radio-group [formControl]="slotTactControl">
              <mat-radio-button
                *ngFor="let tact of AVAILABLE_SLOT_TACT"
                color="primary"
                [value]="tact"
              >
                <div>
                  <div>{{ tact * 60 | durationFormatter }}</div>
                  <div class="description-color">
                    ({{
                      'lib_calendar.available-slot-selection-form.text.slot_tact_example.' +
                        tact | translate
                    }})
                  </div>
                </div>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </lib-base-card>
      </ng-template>
      }
    </h3>

    <mat-button-toggle-group
      [formControl]="viewMode"
      [hideSingleSelectionIndicator]="true"
    >
      <mat-button-toggle [value]="AVAILABLE_SLOT_VIEW_MODE.DATE">{{
        'lib_calendar.available-slot-selection-form.buttons.date-view'
          | translate
      }}</mat-button-toggle>
      <mat-button-toggle [value]="AVAILABLE_SLOT_VIEW_MODE.WEEK">{{
        'lib_calendar.available-slot-selection-form.buttons.week-view'
          | translate
      }}</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <lib-spacer [height]="10"></lib-spacer>

  <lib-base-card [isLoading]="isLoading">
    <div class="card-content">
      <ng-container
        *ngIf="isAbleToDisplayAppointmentTimeSlots(); else selectServiceHint"
      >
        <lib-calendar-available-slot-selection-by-week
          *ngIf="
            viewMode.value === AVAILABLE_SLOT_VIEW_MODE.WEEK;
            else viewModeAsDate
          "
          [isLoading]="isLoading"
          [disabled]="isLoading"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [availableSlots]="availableSlots"
          [selectedProducts]="selectedProducts"
          [presetSelectedSlot]="selectedStartTime"
          (selectedDateRage)="selectDateRangeChanged($event)"
          (selectedSlot)="selectSlotChanged($event)"
        ></lib-calendar-available-slot-selection-by-week>

        <ng-template #viewModeAsDate>
          <lib-calendar-available-slot-selection-by-date
            [isLoading]="isLoading"
            [disabled]="isLoading"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [availableSlots]="availableSlots"
            [selectedProducts]="selectedProducts"
            [presetSelectedSlot]="selectedStartTime"
            (selectedDate)="selectDateChanged($event)"
            (selectedSlot)="selectSlotChanged($event)"
          ></lib-calendar-available-slot-selection-by-date>
        </ng-template>
      </ng-container>
      <ng-template #selectServiceHint>
        <lib-info-box>
          <span>{{
            'lib_calendar.available-slot-selection-form.text.date-time-selection-hint'
              | translate
          }}</span>
        </lib-info-box>
      </ng-template>
    </div>
  </lib-base-card>
</div>
